// ported from https://github.com/muxinc/videojs-mux-kit/blob/main/src/plugins/vtt-thumbnails.js

const VTT_CUE_REGEX = /([0-9]{2}:)?([0-9]{2}:)?[0-9]{2}(.[0-9]{3})?( ?--> ?)([0-9]{2}:)?([0-9]{2}:)?[0-9]{2}(.[0-9]{3})?[\r\n]{1}.*/gi;
const VTT_CUE_SPLIT_REGEX = /[\r\n][\r\n]/i;
const getPropsFromCueUrl = cueStr => {
  const imageDefSplit = cueStr.split(/#xywh=/i);
  const imageUrl = imageDefSplit[0];
  const imageCoords = imageDefSplit[1];
  const splitCoords = imageCoords.match(/[0-9]+/gi);
  if (!splitCoords || splitCoords.length < 4) {
    throw new Error('Invalid image coordinates definition');
  }
  return {
    x: splitCoords[0],
    y: splitCoords[1],
    w: splitCoords[2],
    h: splitCoords[3],
    image: imageUrl
  };
};
const getVttCss = vttImageDef => {
  if (!vttImageDef.match(/#xywh=/i)) {
    return {
      background: `url("${vttImageDef}")`,
      width: 0,
      height: 0,
      url: vttImageDef
    };
  }
  const imageProps = getPropsFromCueUrl(vttImageDef);
  return {
    background: `url("${imageProps.image}") no-repeat -${imageProps.x}px -${imageProps.y}px`,
    width: Number(imageProps.w),
    height: Number(imageProps.h),
    url: imageProps.image
  };
};
const deconstructTimestamp = timestamp => {
  const [timeParts, millisecondsStr = '0'] = timestamp.split('.');
  const timePartsSplit = timeParts.split(':');
  const paddedParts = Array(3 - timePartsSplit.length).fill('0').concat(timePartsSplit);
  const [hours, minutes, seconds] = paddedParts.map(part => parseInt(part, 10) || 0);
  return {
    milliseconds: parseInt(millisecondsStr, 10) || 0,
    seconds,
    minutes,
    hours
  };
};
const getSecondsFromTimestamp = timestamp => {
  const timestampParts = deconstructTimestamp(timestamp);
  return timestampParts.hours * (60 * 60) + timestampParts.minutes * 60 + timestampParts.seconds + timestampParts.milliseconds / 1000;
};
export const fetchVttFile = async playbackId => {
  const storyboardUrl = `https://image.mux.com/${playbackId}/storyboard.vtt`;
  try {
    const response = await window.fetch(storyboardUrl);
    if (!response.ok) {
      throw new Error(`Failed to fetch VTT file: ${response.status} ${response.statusText}`);
    }
    return await response.text();
  } catch (error) {
    console.error('Error fetching VTT file:', error);
    throw error;
  }
};
const processVttData = data => {
  const processedVtts = [];
  const vttDefinitions = data.split(VTT_CUE_SPLIT_REGEX);
  vttDefinitions.forEach(vttDef => {
    if (vttDef.match(VTT_CUE_REGEX)) {
      const vttDefSplit = vttDef.split(/[\r\n]/i);
      const vttTiming = vttDefSplit[0];
      const vttTimingSplit = vttTiming.split(/ ?--> ?/i);
      const vttTimeStart = vttTimingSplit[0];
      const vttTimeEnd = vttTimingSplit[1];
      const vttImageDef = vttDefSplit[1];
      if (vttImageDef) {
        const vttCssDef = getVttCss(vttImageDef);
        processedVtts.push({
          start: getSecondsFromTimestamp(vttTimeStart),
          end: getSecondsFromTimestamp(vttTimeEnd),
          css: vttCssDef
        });
      }
    }
  });
  return [...processedVtts].sort((a, b) => a.start - b.start);
};
export const fetchAndProcessVtt = async playbackId => {
  const vttData = await fetchVttFile(playbackId);
  return processVttData(vttData);
};